// Generated by CoffeeScript 1.12.7

/**
A collection of methods for creating and managing page session variables.

@class session
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/session',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.session = factory();
  }
})(this, function() {
  var session;
  return session = {

    /**
    		Determines if the browser supports sessionStorage.
    
    		@prop available
    		@return {Boolean} whether sessionsStorage is available or not
     */
    available: function() {
      var test;
      test = 'test';
      try {
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        return true;
      } catch (error) {
        return false;
      }
    },

    /**
    		Creates a session object.
    
    		@method set
    		@param {String} name the name of the session object
    		@param {String} value the value of the session object
    		@return {String} session
     */
    set: function(name, value) {
      if (name) {
        if (value && typeof value === 'object' && value.constructor === Object) {
          value = JSON.stringify(value);
        }
        try {
          return sessionStorage.setItem(name, value);
        } catch (error) {}
      }
    },

    /**
    		Retrieves a session object.
    
    		@method get
    		@param {String} name the name of the session object being retrieved
    		@param {String} defaultVal the value of the session object if retrieved value is undefined
    		@return {String}
     */
    get: function(name, defaultVal) {
      var e, value;
      try {
        value = sessionStorage.getItem(name);
      } catch (error) {
        e = error;
        value = null;
      }
      if (!value) {
        value = defaultVal;
      }
      try {
        value = JSON.parse(value);
      } catch (error) {}
      return value;
    },

    /**
    		Removes a session object.
    
    		@method remove
    		@param {String} name the name of the session object being retrieved
    		@return {String}
     */
    remove: function(name) {
      return sessionStorage.removeItem(name);
    }
  };
});

